export interface StreamInterface {
    id: number;
    bitmovinId: string;
    title: string;
    description?: string;
    dateAdded?: Date;
    accessToken?: string;
    points?: number;
}


export class Stream implements StreamInterface {
    public id: number;
    public bitmovinId: string;
    public title: string;
    public description?: string;
    public dateAdded?: Date;
    public accessToken?: string;
    public points?: number;

    constructor(
        id: number,
        bitmovinId: string,
        title: string,
        description?: string,
        dateAdded?: Date,
        accessToken?: string,
        points?: number
    ) {
        this.id = id;
        this.bitmovinId = bitmovinId;
        this.title = title;
        this.description = description;
        this.dateAdded = dateAdded;
        this.accessToken = accessToken;
        this.points = points;
    }

    static fromJson(json: any): Stream {
        return new Stream(
            json.id,
            json.bitmovinId,
            json.title,
            json.description,
            json.dateAdded ? new Date(json.dateAdded) : undefined,
            json.accessToken,
            json.points
        );
    }

    static fromJsonArray(jsonArray: any[]): Stream[] {
        return jsonArray.map(item => Stream.fromJson(item));
    }
}
